var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNullAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.278,
    cy: 50.278,
    r: 45.833,
    fill: "#E3FBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1.165 67.684a1.111 1.111 0 00-.035 1.933L36.4 90.48c.191.113.412.166.633.153l13.322-.816a1.11 1.11 0 00.544-.181l26.386-17.394c.66-.434.668-1.4.015-1.845L41.873 46.243a1.111 1.111 0 00-1.157-.058l-39.551 21.5z",
    fill: "#014266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.464 54.875L20.19 72.3l-.002-25.31 30.277-17.425v25.309z",
    fill: "#0B9F6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.74 72.3L50.463 54.876l.002-25.309L80.74 46.991V72.3z",
    fill: "#007B56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.74 72.3L50.463 54.876l.002-25.309L80.74 46.991V72.3z",
    fill: "#242629"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M50.468 29.58L22.71 64.795l27.758 17.779V29.58z",
    fill: "#007B56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.74 72.3L50.463 89.727 20.187 72.3l30.276-17.425L80.74 72.3z",
    fill: "#0B9F6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.464 89.727L20.188 72.302l.001-25.311 30.275 17.426v25.31z",
    fill: "#007B56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.74 72.302L50.465 89.727l-.002-25.31L80.74 46.99v25.311z",
    fill: "#8BD383"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.329 78.87l-3.68 2.084v-24.34l3.68-2.34V78.87z",
    fill: "#007B56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.464 29.566L41.03 18.41 9.897 34.812 20.221 46.99l30.243-17.425z",
    fill: "#16AF6F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M50.464 29.566L41.03 18.41 9.898 34.823l10.323 12.168 30.243-17.425z",
    fill: "#8BD383"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.99 17.843L50.464 29.55 80.74 46.99l9.815-12.734L59.99 17.843zm-.401 45.172l30.127-17.484-8.976 1.46-30.277 17.447 9.126-1.423z",
    fill: "#007B56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.123 54.446v-.009l-1.555-.895v25.31l1.464.843 1.846 1.062v-25.3l-1.755-1.011z",
    fill: "#242629"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.187 46.99l-6.962-1.07L43.28 63.44l7.183.998L20.187 46.99z",
    fill: "#8BD383"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.187 46.99l-6.962-1.07L43.28 63.44l7.183.998L20.187 46.99z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullAds);
export default __webpack_public_path__ + "static/media/NullAds.00528cc0f3f08f6a59cf94437f583f1c.svg";
export { ForwardRef as ReactComponent };